export interface Review {
  id: number;
  name: string;
  handle: string;
  rating: number;
  comment: string;
  date: string;
  avatarUrl: string;
}

export const reviews: Review[] = [
  {
    id: 1,
    name: "田中 さくら",
    handle: "@sakura_nail_lover",
    rating: 5,
    comment: "初めて伺いましたが、カウンセリングがとても丁寧で安心できました。仕上がりも写真で見ていた通りの美しさで、友達にも自慢できるネイルになりました！次回もぜひお願いしたいと思います。",
    date: "2026年3月",
    avatarUrl: "https://public.readdy.ai/ai/img_res/2293e488e2e44a3b5a909a201b329596.jpg"
  },
  {
    id: 2,
    name: "山本 美咲",
    handle: "@misaki_beauty_life",
    rating: 5,
    comment: "結婚式のブライダルネイルをお願いしました。イメージを伝えただけで想像以上の素晴らしいデザインに仕上げていただきました。親族みんなに褒めていただいて本当に感謝しています。",
    date: "2026年2月",
    avatarUrl: "https://readdy.ai/api/search-image?query=elegant%20Japanese%20woman%20headshot%20portrait%2C%20refined%20smile%2C%20soft%20studio%20lighting%2C%20cream%20white%20background%2C%20professional%20beauty%20photography%2C%20late%2020s%20early%2030s%2C%20sophisticated%20look&width=80&height=80&seq=av2&orientation=squarish"
  },
  {
    id: 3,
    name: "鈴木 あかり",
    handle: "@akari_nails_tokyo",
    rating: 5,
    comment: "毎月通っています！スタッフの方がとても明るく居心地の良いサロンです。季節に合わせたデザイン提案が素晴らしく、毎回楽しみにしています。技術力も高くて大満足です。",
    date: "2026年3月",
    avatarUrl: "https://readdy.ai/api/search-image?query=cheerful%20Japanese%20woman%20portrait%20close%20up%2C%20bright%20friendly%20smile%2C%20natural%20lighting%2C%20off%20white%20background%2C%20casual%20yet%20stylish%20look%2C%20mid%2020s%2C%20beauty%20photography%20portrait&width=80&height=80&seq=av3&orientation=squarish"
  },
  {
    id: 4,
    name: "伊藤 はるか",
    handle: "@haruka_atelier_fan",
    rating: 5,
    comment: "3Dフラワーネイルに挑戦してみましたが、本当に感動するほど美しい仕上がりでした。手元を見るたびに気分が上がります！丁寧な施術で長持ちするのも嬉しいです。",
    date: "2026年1月",
    avatarUrl: "https://readdy.ai/api/search-image?query=pretty%20Japanese%20woman%20portrait%20headshot%2C%20gentle%20warm%20smile%2C%20soft%20diffused%20lighting%2C%20light%20cream%20background%2C%20fashionable%20appearance%2C%20early%2030s%2C%20beauty%20portrait%20photography%2C%20high%20quality&width=80&height=80&seq=av4&orientation=squarish"
  }
];
